import {
	createRouter,
	createWebHashHistory
} from "vue-router"
import {useMainStore} from './store.js';

const routes = [
	{
		name: 'login',
		path: '/',
		component: () => import("@/views/login-index.vue"),
	},
	{
		name: 'layout',
		path: '/layout',
		component: () => import("@/views/layout-default.vue"),
	}
]

const router = createRouter({
	history: createWebHashHistory(),
	routes,
})


//导航守卫
router.beforeEach((to, from, next) => {
	const mainStore = useMainStore();
	const env_name = mainStore.globalConfig.env_name || "GM";
	document.title = `超迷【${env_name}】后台管理`;
	// 开启进度条
	// NProgress.start()

	//跳转登录
	/*
	if (!mainStore.user && to.name !== "Login") next({
		name: 'Login'
	})
	else next()
	*/
   next()
})


router.afterEach(() => {
	// 关闭进度条
	// NProgress.done()
})
export default router;
